
import {getResourceUploadUlr} from '../../api'
export default {
    /**
     * 面包屑数据
     * 主菜单索引
     */
    state: {
        urls: ''
    },
    mutations: {
        __changeUrls (state, val) {
            state.urls = val
        }
    },
    actions: {
        changeUrlsAction ({commit}, val) {
            // 预处理各个资源上传地址
            const maps = ['image']
            const promisList = maps.map(item => {
                return new Promise((resolve) => {
                    getResourceUploadUlr({type: item, chunk: 0}).then(res => {
                        if (!res) {
                            resolve(undefined)
                            return
                        }
                        resolve({ type: item, url: res.uploadUrl })
                    })
                })
            })
            return Promise.all(promisList).then(res => {
                commit('__changeUrls', res)
                return res
            })
        }
    },
    namespaced: true
}



// WEBPACK FOOTER //
// ./src/store/uploadUrls/index.js